import React from 'react';
import { HBox, VBox } from '../../layout';
import { Icon } from '../../basic';
import {
  convertNumberToFileSize,
  getIconByMimeType,
  stripFileExtension
} from '../../../util';
import type { CommonMessageProps } from './ChatMessageFrame';
import { ChatMessageFrame } from './ChatMessageFrame';

/**
 * Props for a {@link ChatFileMessage} component.
 */
export type ChatFileMessageProps = CommonMessageProps & {
  fileName: string;
  /** Called on click; resolves to a download URL, or `undefined`. */
  loadUrl: () => Promise<string | undefined>;
  mimeType?: string;
  size?: number;
};

export default function ChatFileMessage({
  person,
  fileName,
  loadUrl,
  mimeType,
  size,
  status,
  ...frameProps
}: Readonly<ChatFileMessageProps>): React.JSX.Element {
  // Not on the server yet: no download or reactions.
  const isPending = status === 'sending';

  return (
    <ChatMessageFrame
      prefix="file"
      person={person}
      status={status}
      reactionsDisabled={isPending}
      {...frameProps}
    >
      <HBox
        className={`file-message-body ${person.isSender ? 'sender' : ''} ${
          isPending ? 'pending' : ''
        }`}
      >
        <Icon
          aria-label={undefined}
          iconName={getIconByMimeType(mimeType, fileName)}
          className="file-message-icon"
        />
        <VBox className="file-message-detail">
          <div className="file-message-name">
            {stripFileExtension(fileName)}
          </div>
          {size !== undefined && (
            <div className="file-message-size gray">
              {convertNumberToFileSize(size)}
            </div>
          )}
        </VBox>
        {/* TODO: Download button SENSE-37989 */}
      </HBox>
    </ChatMessageFrame>
  );
}
